import React, { FC, useRef, useState } from 'react';
import { contentModalViewStore } from 'src/store/modal';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import { settlementDataStore } from 'src/store/settlementInfo';
// import GridList from './List';
import GridList from 'src/components/molecules/table/IncomeDetail/List';
import '../tableRef.scss';
import './style.scss';

interface Props {
  type: string;
  data: any;
}
const IncomeGrid: FC<Props> = ({ type, data }) => {
  const setContentModalState = contentModalViewStore((state: any) => state.set);
  const settlementDataInitState = settlementDataStore((state: any) => state.bind);
  const settlementDataParam = settlementDataStore((state: any) => state.param);
  const settlementData = settlementDataStore((state: any) => state.result).data || {};

  const viewData: any = settlementData || [];
  const ocrEvt = () => {};
  const closeEvt = () => {
    setContentModalState({
      active: '',
    });
  };
  const help = {
    title: '파일에서 종전 근무지 정보를 자동 추출합니다.',
    content: '(근로소득 원천징수 영수증 파일 선택)',
  };
  //
  const listGrid = () => {
    return (
      <div className="_list_grid">
        {/* <TaxTopButton /> */}
        <GridList data={viewData} />
        <div className="_bottom_div">
          <div className="_btn">
            <DefaultButton
              text="확인"
              styleDef={{ width: '300px', height: '38px' }}
              clickEvent={e => closeEvt()}
              icon=""
              type="type5"
              iconStyleDef={{ fontSize: '18px' }}
            />
          </div>
        </div>
        {/* <TaxBottomDesc /> */}
      </div>
    );
  };

  const viewGrid = () => {
    return listGrid();
  };

  return (
    <div className="_income_detail_div_layout">
      <div className="_content_div">{viewGrid()}</div>
    </div>
  );
};

export default IncomeGrid;
